/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonRelationRef,
  PersonRelationRefOptional,
  PersonRelationRefMetaI,
  PersonRelationRefTrackedI,
} from "./person-relation-ref";
import {
  PersonRelationRefTracked,
  PersonRelationRefMeta,
} from "./person-relation-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonRelationType,
  PersonRelationTypeOptional,
  PersonRelationTypeMetaI,
  PersonRelationTypeTrackedI,
} from "./person-relation-type";
import {
  PersonRelationTypeTracked,
  PersonRelationTypeMeta,
} from "./person-relation-type";

/**
 *
 * @export
 * @interface PersonRelationBase
 */
export interface PersonRelationBaseOptional extends PersonRelationRefOptional {
  /**
   *
   * @type {number}
   * @memberof PersonRelationBase
   */
  relationId?: number;
  /**
   *
   * @type {boolean}
   * @memberof PersonRelationBase
   */
  isPrimary?: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonRelationBase
   */
  aTitleOverride?: string;
  /**
   *
   * @type {string}
   * @memberof PersonRelationBase
   */
  bTitleOverride?: string;
  /**
   *
   * @type {PersonRelationType}
   * @memberof PersonRelationBase
   */
  relationTypeId?: PersonRelationType;
}

export interface PersonRelationBase
  extends PersonRelationBaseOptional, PersonRelationRef {
  /**
   *
   * @type {number}
   * @memberof PersonRelationBase
   */
  relationId: number;
  /**
   *
   * @type {boolean}
   * @memberof PersonRelationBase
   */
  isPrimary?: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonRelationBase
   */
  aTitleOverride?: string;
  /**
   *
   * @type {string}
   * @memberof PersonRelationBase
   */
  bTitleOverride?: string;
  /**
   *
   * @type {PersonRelationType}
   * @memberof PersonRelationBase
   */
  relationTypeId?: PersonRelationType;
}

export interface PersonRelationBaseTrackedI extends PersonRelationRefOptional {
  /**
   *
   * @type {number}
   * @memberof PersonRelationBase
   */
  relationId?: number;
  relationIdIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonRelationBase
   */
  isPrimary?: boolean;
  isPrimaryIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonRelationBase
   */
  aTitleOverride?: string;
  aTitleOverrideIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonRelationBase
   */
  bTitleOverride?: string;
  bTitleOverrideIsSet: boolean;
  /**
   *
   * @type {PersonRelationType}
   * @memberof PersonRelationBase
   */
  relationTypeId?: PersonRelationType;
  relationTypeIdIsSet: boolean;
}

transformDatesMap.set(
  "PersonRelationBase",
  function (model: PersonRelationBase) {},
);

export type PersonRelationBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  relationId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  isPrimary: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  aTitleOverride: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  bTitleOverride: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  relationTypeId: PropertyMeta<PersonRelationTypeMetaI>;
}>;

export var PersonRelationBaseMeta: PersonRelationBaseMetaI =
  {} as PersonRelationBaseMetaI;
PersonRelationBaseMeta = typeMeta("PersonRelationBase", {
  relationId: propertyMeta(
    "relationId",
    false,
    true,
    true,
    MetaTypesBase.number,
  ),
  isPrimary: propertyMeta(
    "isPrimary",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  aTitleOverride: propertyMeta(
    "aTitleOverride",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  bTitleOverride: propertyMeta(
    "bTitleOverride",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  relationTypeId: propertyMeta(
    "relationTypeId",
    false,
    false,
    false,
    PersonRelationTypeMeta,
  ),
});

const metaI = PersonRelationBaseMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([PersonRelationRefMeta]);
  metaI.relationId.inheritedFrom = PersonRelationRefMeta.relationId;
});

export class PersonRelationBaseTracked
  extends PersonRelationRefTracked
  implements PersonRelationBaseTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  relationId__I?: number = undefined;

  get relationIdIsSet() {
    return this.relationId !== undefined;
  }
  set relationIdIsSet(v: boolean) {}
  set relationId(v: undefined | number) {
    if (v !== undefined) {
      this.relationId__I = v;
      this.relationIdIsSet = true;
    } else {
      this.relationId__I = v || undefined;
      this.relationIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get relationId() {
    return this.relationId__I;
  }
  isPrimary__I?: boolean = undefined;
  isPrimaryIsSet: boolean = false;
  set isPrimary(v: undefined | boolean) {
    if (v !== undefined) {
      this.isPrimary__I = v;
      this.isPrimaryIsSet = true;
    } else {
      this.isPrimary__I = v || undefined;
      this.isPrimaryIsSet = false;
    }
    this.changeTracker = true;
  }
  get isPrimary() {
    return this.isPrimary__I;
  }
  aTitleOverride__I?: string = undefined;
  aTitleOverrideIsSet: boolean = false;
  set aTitleOverride(v: undefined | string) {
    if (v !== undefined) {
      this.aTitleOverride__I = v;
      this.aTitleOverrideIsSet = true;
    } else {
      this.aTitleOverride__I = v || undefined;
      this.aTitleOverrideIsSet = false;
    }
    this.changeTracker = true;
  }
  get aTitleOverride() {
    return this.aTitleOverride__I;
  }
  bTitleOverride__I?: string = undefined;
  bTitleOverrideIsSet: boolean = false;
  set bTitleOverride(v: undefined | string) {
    if (v !== undefined) {
      this.bTitleOverride__I = v;
      this.bTitleOverrideIsSet = true;
    } else {
      this.bTitleOverride__I = v || undefined;
      this.bTitleOverrideIsSet = false;
    }
    this.changeTracker = true;
  }
  get bTitleOverride() {
    return this.bTitleOverride__I;
  }
  relationTypeId__I?: PersonRelationType = undefined;
  relationTypeIdIsSet: boolean = false;
  set relationTypeId(v: undefined | PersonRelationType) {
    if (v !== undefined) {
      this.relationTypeId__I = v;
      this.relationTypeIdIsSet = true;
    } else {
      this.relationTypeId__I = v || undefined;
      this.relationTypeIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get relationTypeId() {
    return this.relationTypeId__I;
  }
  constructor(config?: PersonRelationBaseOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.relationIdIsSet == true && other?.relationIdIsSet == true)
      return this.relationId == other.relationId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.relationId) {
      this.relationIdIsSet = true;
    }
  }
  assignFrom(
    config: PersonRelationBaseOptional,
    options?: AssignOptions,
  ): PersonRelationBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.relationId &&
      this.relationIdApplyFilter(optionsRequired.filter)
    ) {
      this.relationId = config.relationId;
      if (optionsRequired.unassign) this.relationIdIsSet = false;
      else this.relationIdIsSet = true;
    }
    if (config.isPrimary && this.isPrimaryApplyFilter(optionsRequired.filter)) {
      this.isPrimary = config.isPrimary;
      if (optionsRequired.unassign) this.isPrimaryIsSet = false;
      else this.isPrimaryIsSet = true;
    }
    if (
      config.aTitleOverride &&
      this.aTitleOverrideApplyFilter(optionsRequired.filter)
    ) {
      this.aTitleOverride = config.aTitleOverride;
      if (optionsRequired.unassign) this.aTitleOverrideIsSet = false;
      else this.aTitleOverrideIsSet = true;
    }
    if (
      config.bTitleOverride &&
      this.bTitleOverrideApplyFilter(optionsRequired.filter)
    ) {
      this.bTitleOverride = config.bTitleOverride;
      if (optionsRequired.unassign) this.bTitleOverrideIsSet = false;
      else this.bTitleOverrideIsSet = true;
    }
    if (
      config.relationTypeId &&
      this.relationTypeIdApplyFilter(optionsRequired.filter)
    ) {
      this.relationTypeId = config.relationTypeId;
      if (optionsRequired.unassign) this.relationTypeIdIsSet = false;
      else this.relationTypeIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonRelationBaseTrackedI {
    const cloned = {} as PersonRelationBaseTrackedI;
    if (
      this.relationIdIsSetDeep() &&
      this.relationIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.relationIdIsSet = true;
      cloned.relationId = this.relationId;
    } else {
      //cloned.relationIdIsSet = false
    }
    if (
      this.isPrimaryIsSetDeep() &&
      this.isPrimaryApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isPrimaryIsSet = true;
      cloned.isPrimary = this.isPrimary;
    } else {
      //cloned.isPrimaryIsSet = false
    }
    if (
      this.aTitleOverrideIsSetDeep() &&
      this.aTitleOverrideApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.aTitleOverrideIsSet = true;
      cloned.aTitleOverride = this.aTitleOverride;
    } else {
      //cloned.aTitleOverrideIsSet = false
    }
    if (
      this.bTitleOverrideIsSetDeep() &&
      this.bTitleOverrideApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.bTitleOverrideIsSet = true;
      cloned.bTitleOverride = this.bTitleOverride;
    } else {
      //cloned.bTitleOverrideIsSet = false
    }
    if (
      this.relationTypeIdIsSetDeep() &&
      this.relationTypeIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.relationTypeIdIsSet = true;
      cloned.relationTypeId = this.relationTypeId;
    } else {
      //cloned.relationTypeIdIsSet = false
    }
    if (!isDeleted(this) && !this.relationIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonRelationBaseTrackedI {
    if (!this.relationIdApplyFilter(filter)) this.relationIdIsSet = false;

    if (!this.isPrimaryApplyFilter(filter)) this.isPrimaryIsSet = false;

    if (!this.aTitleOverrideApplyFilter(filter))
      this.aTitleOverrideIsSet = false;

    if (!this.bTitleOverrideApplyFilter(filter))
      this.bTitleOverrideIsSet = false;

    if (!this.relationTypeIdApplyFilter(filter))
      this.relationTypeIdIsSet = false;

    return this;
  }
  relationIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonRelationBaseMeta.relationId,
      PersonRelationBaseMeta,
      this.relationId,
      this,
    );
  }
  relationIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.relationIdIsSet && this.relationIdApplyFilter(filter)) return true;

    return false;
  }
  isPrimaryApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonRelationBaseMeta.isPrimary,
      PersonRelationBaseMeta,
      this.isPrimary,
      this,
    );
  }
  isPrimaryIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isPrimaryIsSet && this.isPrimaryApplyFilter(filter)) return true;

    return false;
  }
  aTitleOverrideApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonRelationBaseMeta.aTitleOverride,
      PersonRelationBaseMeta,
      this.aTitleOverride,
      this,
    );
  }
  aTitleOverrideIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.aTitleOverrideIsSet && this.aTitleOverrideApplyFilter(filter))
      return true;

    return false;
  }
  bTitleOverrideApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonRelationBaseMeta.bTitleOverride,
      PersonRelationBaseMeta,
      this.bTitleOverride,
      this,
    );
  }
  bTitleOverrideIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.bTitleOverrideIsSet && this.bTitleOverrideApplyFilter(filter))
      return true;

    return false;
  }
  relationTypeIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonRelationBaseMeta.relationTypeId,
      PersonRelationBaseMeta,
      this.relationTypeId,
      this,
    );
  }
  relationTypeIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.relationTypeIdIsSet && this.relationTypeIdApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.relationIdIsSetDeep(filter)) return true;
    if (this.isPrimaryIsSetDeep(filter)) return true;
    if (this.aTitleOverrideIsSetDeep(filter)) return true;
    if (this.bTitleOverrideIsSetDeep(filter)) return true;
    if (this.relationTypeIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
